import { useEffect } from "react";
import { getLang } from "../../../store/uiStore";

export default function AnalyticsFilters({
    filters,
    values,
    onChange,
}) {
    const lang = getLang();
    const tr = {
        filters: lang === "ru" ? "Фильтры" : "Филтрҳо",
        subtitle: lang === "ru"
            ? "Выберите период и территорию для просмотра данных"
            : "Барои дидани маълумот давра ва ҳудудро интихоб кунед",
        year: lang === "ru" ? "Год" : "Сол",
        period: lang === "ru" ? "Период" : "Давра",
        region: lang === "ru" ? "Регион" : "Минтақа",
        allRegions: lang === "ru" ? "Все регионы" : "Ҳамаи минтақаҳо",
        district: lang === "ru" ? "Район / город" : "Ноҳия / шаҳр",
        allDistricts: lang === "ru" ? "Все районы" : "Ҳамаи ноҳияҳо",
        legalType: lang === "ru" ? "Юридическая форма" : "Шакли ҳуқуқӣ",
        all: lang === "ru" ? "Все" : "Ҳама",
    };
    const getName = (item) => lang === "ru"
        ? (item.name_ru ?? item.name_tj ?? "")
        : (item.name_tj ?? item.name_ru ?? "");
const handleChange = (field) => (event) => {

        const value = event.target.value;

        onChange((prev) => ({

            ...prev,

            [field]:
                value === ""
                    ? null
                    : value,

        }));

    };


    const districts =
        filters.districts || [];


    const selectedRegion =
        values.region
            ? Number(values.region)
            : null;


    const availableDistricts =
        selectedRegion
            ? districts.filter(
                district =>
                    district.region_id ===
                    selectedRegion
            )
            : districts;


    // ---------------------------------------------
    // При изменении региона сбрасываем район,
    // если он больше не принадлежит региону
    // ---------------------------------------------

    useEffect(() => {

        if (!values.district) {
            return;
        }

        const districtExists =
            availableDistricts.some(
                district =>
                    district.id ===
                    Number(values.district)
            );

        if (!districtExists) {

            onChange(prev => ({
                ...prev,
                district: null,
            }));

        }

    }, [
        values.region,
        values.district,
        availableDistricts,
        onChange,
    ]);


    return (

        <div className="card mb-4 analytics-filters-card">

            <div className="card-body analytics-filters-body">
                <div className="analytics-filters-heading">
                    <div>
                        <div className="analytics-filters-title">{tr.filters}</div>
                        <div className="analytics-filters-subtitle">
                            {tr.subtitle}
                        </div>
                    </div>
                </div>

                <div className="row g-3 analytics-filters-row">

                    {/* Год */}

                    <div className="col-md-2">

                        <label className="form-label">
                            {tr.year}
                        </label>

                        <select
                            className="form-select"
                            value={
                                values.year ?? ""
                            }
                            onChange={
                                handleChange(
                                    "year"
                                )
                            }
                        >

                            {filters.years.map(
                                year => (

                                    <option
                                        key={year}
                                        value={year}
                                    >
                                        {year}
                                    </option>

                                )
                            )}

                        </select>

                    </div>


                    {/* Период */}

                    <div className="col-md-2">

                        <label className="form-label">
                            {tr.period}
                        </label>

                        <select
                            className="form-select"
                            value={
                                values.quarter ?? ""
                            }
                            onChange={
                                handleChange(
                                    "quarter"
                                )
                            }
                        >

                            {filters.periods.map(
                                period => (

                                    <option
                                        key={
                                            period.quarter
                                        }
                                        value={
                                            period.quarter
                                        }
                                    >
                                        {lang === "ru" ? (period.title_ru ?? period.title) : (period.title_tj ?? period.title_ru ?? period.title)}
                                    </option>

                                )
                            )}

                        </select>

                    </div>


                    {/* Регион */}

                    <div className="col-md-3">

                        <label className="form-label">
                            {tr.region}
                        </label>

                        <select
                            className="form-select"
                            value={
                                values.region ?? ""
                            }
                            onChange={
                                handleChange(
                                    "region"
                                )
                            }
                        >

                            <option value="">
                                {tr.allRegions}
                            </option>

                            {filters.regions.map(
                                region => (

                                    <option
                                        key={
                                            region.id
                                        }
                                        value={
                                            region.id
                                        }
                                    >
                                        {getName(region)}
                                    </option>

                                )
                            )}

                        </select>

                    </div>


                    {/* Район / город */}

                    <div className="col-md-3">

                        <label className="form-label">
                            {tr.district}
                        </label>

                        <select
                            className="form-select"
                            value={
                                values.district ?? ""
                            }
                            onChange={
                                handleChange(
                                    "district"
                                )
                            }
                            disabled={
                                availableDistricts.length === 0
                            }
                        >

                            <option value="">
                                {tr.allDistricts}
                            </option>

                            {availableDistricts.map(
                                district => (

                                    <option
                                        key={
                                            district.id
                                        }
                                        value={
                                            district.id
                                        }
                                    >
                                        {getName(district)}
                                    </option>

                                )
                            )}

                        </select>

                    </div>


                    {/* Юридическая форма */}

                    <div className="col-md-2">

                        <label className="form-label">
                            {tr.legalType}
                        </label>

                        <select
                            className="form-select"
                            value={
                                values.legal_type ?? ""
                            }
                            onChange={
                                handleChange(
                                    "legal_type"
                                )
                            }
                        >

                            <option value="">
                                {tr.all}
                            </option>

                            {filters.legal_types.map(
                                type => (

                                    <option
                                        key={
                                            type.value
                                        }
                                        value={
                                            type.value
                                        }
                                    >
                                        {
                                            lang === "ru"
                                                ? (type.label_ru ?? type.label_tj ?? type.label ?? "")
                                                : (type.label_tj ?? type.label_ru ?? type.label ?? "")
                                        }
                                    </option>

                                )
                            )}

                        </select>

                    </div>

                </div>

            </div>

        </div>

    );
}
